export enum EnumType {
    Text = 'Text',
    Number = 'Number',
    List = 'List',
    MList = 'MList',
    Check = 'Check',
    Range = 'Range',
    Date = 'Date',
    Datetime = 'Datetime',
    Time = 'Time',
}
